import { Component } from 'react'

const AutocompleteHOC = (WrappedComponent) =>
  class extends Component {
    state = {
      value: '',
      suggestions: []
    }

    changeHandler = (event, { newValue }) => {
      this.setState({ value: newValue })
    }

    setValue = (value) => {
      this.setState({ value })
    }

    setSuggestions = (suggestions) => {
      this.setState({ suggestions })
    }

    onSuggestionsClearRequested = () => {
      this.setState({ suggestions: [] })
    }

    clearHandler = () => {
      this.setState({ value: '' })
    }

    render() {
      const props = {
        ...this.props,
        state: this.state,
        changeHandler: this.changeHandler,
        onSuggestionsClearRequested: this.onSuggestionsClearRequested,
        setValue: this.setValue,
        setSuggestions: this.setSuggestions,
        clearHandler: this.clearHandler
      }

      return <WrappedComponent {...props} />
    }
  }

export default AutocompleteHOC
